import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { useClientDashboard } from '@/queries/clientDashboards'
import { AccountTeamEditor } from './AccountTeamEditor'
import { EmailDomainsCard } from './EmailDomainsCard'
import { LinearSyncCard } from './LinearSyncCard'
import { RemoveClientDialog } from './RemoveClientDialog'

export function ClientSettingsView({ companyId }: { companyId: string }) {
  const { data } = useClientDashboard(companyId)
  if (!data) return null
  const dashboard = data.data

  return (
    <div className="max-w-2xl space-y-4">
      <AccountTeamEditor key={`team-${companyId}`} dashboard={dashboard} />
      <EmailDomainsCard key={`domains-${companyId}`} companyId={companyId} />
      <LinearSyncCard companyId={companyId} clientName={dashboard.companyName} />
      <Card className="mt-8 border-etn-danger-subtle">
        <CardHeader>
          <CardTitle>Remove dashboard</CardTitle>
          <CardDescription>Takes this client off Client dashboards. Its settings are kept and come back if you add it again.</CardDescription>
        </CardHeader>
        <CardContent>
          <RemoveClientDialog dashboard={dashboard} />
        </CardContent>
      </Card>
    </div>
  )
}
